import { Badge, Button, HStack, Text } from '@chakra-ui/react';

export function financialErrorMessage(error: unknown): string {
  const data = (error as { response?: { data?: unknown } })?.response?.data;
  if (typeof data === 'string' && data.trim()) return data;
  if (data && typeof data === 'object') {
    const record = data as Record<string, unknown>;
    if (typeof record.detail === 'string') return record.detail;
    if (typeof record.error === 'string') return record.error;
  }
  return 'Não foi possível carregar os dados financeiros.';
}

export function FinancialPagination({
  page,
  count,
  hasPrevious,
  hasNext,
  isLoading,
  onPrevious,
  onNext,
  itemLabel,
}: {
  page: number;
  count?: number;
  hasPrevious?: boolean;
  hasNext?: boolean;
  isLoading: boolean;
  onPrevious: () => void;
  onNext: () => void;
  itemLabel: [singular: string, plural: string];
}) {
  return (
    <HStack spacing={2} justifyContent="space-between" pt={4} mt={2}>
      <Button onClick={onPrevious} isDisabled={!hasPrevious} variant="outline" size="sm" isLoading={isLoading}>
        ← Anterior
      </Button>
      <HStack spacing={2}>
        <Text fontSize="xs" color="gray.500">
          Página {page}
        </Text>
        {typeof count === 'number' && (
          <Badge colorScheme="gray" borderRadius="full" px={2} fontSize="2xs">
            {count} {count === 1 ? itemLabel[0] : itemLabel[1]}
          </Badge>
        )}
      </HStack>
      <Button onClick={onNext} isDisabled={!hasNext} variant="outline" size="sm" isLoading={isLoading}>
        Próximo →
      </Button>
    </HStack>
  );
}
